import { Input as AntInput } from 'antd';

import { Row, Column } from '@bancobarigui/barihaus';
import { Form, Select } from '@bancobarigui/barihaus';

export function CancelForm() {
  return (
    <>
      <Row gutter={[16, 16]}>
        <Column span={24}>
          <Form.Item
            name="reason"
            label="Motivo"
            rules={[{ required: true, message: 'Campo obrigatório' }]}
          >
            <Select
              placeholder="Selecione o motivo"
              options={[
                { value: 'cliente_desistiu', label: 'Cliente desistiu', disabled: false },
                { value: 'proposta_negada', label: 'Proposta negada', disabled: false },
                { value: 'duplicidade', label: 'Duplicidade', disabled: false },
                { value: 'erro_cadastro', label: 'Erro no cadastro', disabled: false },
                { value: 'outros', label: 'Outros', disabled: false },
              ]}
            />
          </Form.Item>
        </Column>

        <Column span={24}>
          <Form.Item name="additionalInfo" label="Informações Adicionais">
            <AntInput.TextArea
              placeholder="Adicione informações adicionais (opcional)"
              rows={4}
              maxLength={500}
            />
          </Form.Item>
        </Column>
      </Row>
    </>
  );
}
